import { render, staticRenderFns } from "./ParallaxBlock.vue?vue&type=template&id=0437f9d9&"
import script from "./ParallaxBlock.ts?vue&type=script&lang=ts&"
export * from "./ParallaxBlock.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports